import { PHONE, locationSchema } from "../structured-data-core";

export function getSanDiegoStructuredData() {
  const url = "https://restorehair.com/locations/california/san-diego/";
  const description =
    "Find out about your hair transplant options in San Diego with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("San Diego", "4660 La Jolla Village Drive, Suite 500", "San Diego", "CA", PHONE, url, description),
  ];
}
